
import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Control } from 'react-hook-form';
import { z } from 'zod';

// Schema for additional information
export const additionalInfoSchema = z.object({
  additionalInfo: z.string().optional(),
  policyAccepted: z.boolean().refine(val => val === true, {
    message: "Musisz zaakceptować regulamin sklepu",
  }),
});

export type AdditionalInfoValues = z.infer<typeof additionalInfoSchema>;

interface AdditionalInfoSectionProps {
  control: Control<any>;
}

const AdditionalInfoSection: React.FC<AdditionalInfoSectionProps> = ({ control }) => {
  return (
    <div className="space-y-6">
      <FormField
        control={control}
        name="additionalInfo"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Dodatkowe informacje (opcjonalnie)</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="Np. preferowane godziny montażu, informacje o dostępie do budynku, etc."
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={control}
        name="policyAccepted"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                Akceptuję regulamin sklepu i politykę prywatności
              </FormLabel>
              <FormMessage />
            </div>
          </FormItem>
        )}
      />
    </div>
  );
};

export default AdditionalInfoSection;
